// Author Shi Wenlong
// Date 2021-07-08 16:31:15

class SithMesQualityToolBorrowRecord {
constructor({
        id = null,
        toolCode = '',
        toolName = '',
        borrowTime = '',
        returnTime = '',
        borrowPersonName = '',
        borrowerManager = '',
        borrowerDepartment = '',
        borrowApprovePersonName = '',
        remark = '',
        status = '',
        workOrderCode = ''}
= {}) {
    this.id = id;
    this.toolCode = toolCode;
    this.toolName = toolName;
    this.borrowTime = borrowTime;
    this.returnTime = returnTime;
    this.borrowPersonName = borrowPersonName;
    this.borrowerManager = borrowerManager;
    this.borrowerDepartment = borrowerDepartment;
    this.borrowApprovePersonName = borrowApprovePersonName;
    this.remark = remark;
    this.status = status;
    this.workOrderCode = workOrderCode;
}
}

function newEntity() {
return new SithMesQualityToolBorrowRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'toolCode',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.toolCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'toolName',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.toolName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowTime',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.borrowTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'returnTime',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.returnTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowPersonName',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.borrowPersonName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowerManager',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.borrowerManager',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowerDepartment',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.borrowerDepartment',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'borrowApprovePersonName',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.borrowApprovePersonName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'status',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'statusName',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    toolCodeFilter : "",
    toolNameFilter : "",
    borrowTimeRteFilter : "",
    borrowTimeLteFilter : "",
    returnTimeRteFilter : "",
    returnTimeLteFilter : "",
    borrowPersonNameFilter : "",
    borrowerManagerFilter : "",
    borrowerDepartmentFilter : "",
    borrowApprovePersonNameFilter : "",
    statusFilter : "",
    workOrderCodeFilter : "",
    workflowQueryTypeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'toolCodeFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.toolCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'toolNameFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.toolName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.borrowTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'borrowTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.borrowTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'returnTimeRteFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.returnTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'returnTimeLteFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.returnTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'borrowPersonNameFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.borrowPersonName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowerManagerFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.borrowerManager',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowerDepartmentFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.borrowerDepartment',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowApprovePersonNameFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.borrowApprovePersonName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesQualityToolBorrowRecord',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'toolCode',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.toolCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'toolName',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.toolName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowTime',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.borrowTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'returnTime',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.returnTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'borrowPersonName',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.borrowPersonName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowerManager',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.borrowerManager',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowerDepartment',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.borrowerDepartment',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'borrowApprovePersonName',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.borrowApprovePersonName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityToolBorrowRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
]

export {SithMesQualityToolBorrowRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
